/**
 * 縦横比を算出
 */
export const calculateAspectRatio = (width: number, height: number) => {
  return height / width;
};

/**
 * 数値の三桁区切り
 */
export const formatNumber = (num: number | undefined): string => {
  if (num === undefined) {
    return '';
  }
  const numStr = num.toString();
  let formattedNum = '';
  let count = 0;

  for (let i = numStr.length - 1; i >= 0; i--) {
    formattedNum = numStr[i] + formattedNum;
    count++;

    if (count % 3 === 0 && i !== 0) {
      formattedNum = ',' + formattedNum;
    }
  }

  return formattedNum;
};

/**
 * 与えられた生年月日の文字列から、未成年かどうかを判定する
 * @param birthDateStr 生年月日の文字列 (YYYY-MM-DD形式)
 * @returns 未成年の場合はtrue、それ以外はfalse
 */
export function isMinor(birthDateStr: string): boolean {
  const birthDate = new Date(birthDateStr);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  // 月が過ぎていない場合は、年齢を1つ減らす
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age < 18;
}

/**
 * 文字列をBool値に変換
 */
export const stringToBool = function (str: string | null): boolean {
  if (str === 'true') {
    return true;
  } else if (str === 'false') {
    return false;
  } else {
    return false;
  }
};

/**
 * 画像ファイルパス取得（環境考慮）
 */
export const getFilePath = (file_path: string | undefined, useCacheBusting: boolean = false) => {
  if (file_path != null) {
    const basePath = import.meta.env.PROD
      ? file_path
      : `${import.meta.env.VITE_FOOTBALLLOG_BACKEND_DOMAIN}${file_path}`;

    return useCacheBusting ? `${basePath}?v=${Date.now()}` : basePath;
  } else {
    return undefined;
  }
};

/**
 * 作成から3日以内かどうか
 * @param at 作成日時
 * @returns 作成から3日以内かどうか
 */
export const isNew = (at: string) => {
  const createdAt = new Date(at);
  const now = new Date();
  const threeDaysInMillis = 3 * 24 * 60 * 60 * 1000;
  return now.getTime() - createdAt.getTime() <= threeDaysInMillis;
};
